// extracted by mini-css-extract-plugin
export default {"root":"s7o5Uz","withRating":"Qtl2Ao","innerContainer":"DGXFWj"};